<h2 mat-dialog-title>{{ title | translate }}</h2>
<mat-dialog-content>
  {{ text | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" type="submit" (click)="approve()">
    {{ 'ok' | translate }}
  </button>
  <button mat-button type="button" (click)="cancel()">
    {{ 'cancel' | translate }}
  </button>
</mat-dialog-actions>
